import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative w-6 h-6" }


export default /*@__PURE__*/_defineComponent({
  __name: 'OpenCloseIcon',
  props: {
    isOpen: {
        type: Boolean,
        required: true,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["absolute block w-6 h-0.5 transition-all duration-300 ease-in-out", [__props.isOpen ? 'bg-gray-900 rotate-45 top-3' : 'bg-gray-600 rotate-0 top-1']])
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["absolute block w-6 h-0.5 bg-gray-600 top-3 transition-all duration-300 ease-in-out", { 'opacity-0': __props.isOpen }])
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["absolute block w-6 h-0.5 transition-all duration-300 ease-in-out", [__props.isOpen ? 'bg-gray-900 -rotate-45 top-3' : 'bg-gray-600 rotate-0 top-5']])
    }, null, 2)
  ]))
}
}

})